import Typography from "@material-ui/core/Typography/Typography";
import React from "react";
import LinearProgress from "@material-ui/core/LinearProgress/LinearProgress";
export default function FieldCounterTotal(props) {
    return (
        <div>
            <LinearProgress
                variant="determinate"
                value={(props.length*100)/props.max}
                className={props.length >= props.max ? "textCounterError" : "textCounter"}
                color="primary"
            />
            <Typography
                style={{direction:"ltr",textAlign:"right",display:"flex",alignItems:"center",justifyContent:"space-between",fontSize:14,padding:"0 5px",marginBottom:5}}
                color={props.length >= props.max ? "error" : "primary"}
            >
                <span>{props.max}</span> <span>{props.length}</span>
            </Typography>
        </div>
    );
}